import mapStyler from './mapStyler.js'

export default {
  mixins: [mapStyler],
  data(){
    return {
      MEAN_RADIUS_EARTH_IN_KM: 6371,
      DEG_TO_RAD_DIVISOR: 57.2957795,
      ZOOM_FACTOR: 1.6446
    }
  },
  computed: {
    isMobile(){
      return false
    },
    defaultZoomLevel(){
      if (window.mapsProductModel == "Hotel"){
        return 3
      }else{
        return 3
      }
    }
  },
  created(){
    $("body").addClass("zenit-map-view")
  },
  methods: {
    toRadians(deg){
      return deg/this.DEG_TO_RAD_DIVISOR
    },

    haversine(maxLat, minLat, maxLng, minLng){
      var dLat = maxLat - minLat
      var dLng = maxLng - minLng

      var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(minLat) * Math.cos(maxLat) * Math.sin(dLng/2) * Math.sin(dLng/2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
      return this.MEAN_RADIUS_EARTH_IN_KM * c
    },

    optimalZoomLevel(maxLat, minLat, maxLng, minLng){

      var minMapDimension = Math.min($('#productMap').height(),$('#productMap').width())

      maxLat = this.toRadians(maxLat)
      minLat = this.toRadians(minLat)
      maxLng = this.toRadians(maxLng)
      minLng = this.toRadians(minLng)

      var greatCircleDistance = this.haversine(maxLat, minLat, maxLng, minLng)

      return Math.floor(8 - Math.log(this.ZOOM_FACTOR * greatCircleDistance / Math.sqrt(2 * (minMapDimension * minMapDimension))) / Math.log (2))
    },

    calculateCenterFromResults(){
      var latlngbounds = new google.maps.LatLngBounds();

      var allLat = []
      var allLng = []


      this.results.forEach(r => {
        if (r.coordinates.length == 2){
          var myLatlng = new google.maps.LatLng(r.coordinates[0], r.coordinates[1]);
          latlngbounds.extend(myLatlng);
          allLat.push(r.coordinates[0])
          allLng.push(r.coordinates[1])
        }
      })

      if (this.results.length > 5){
        this.map.zoom = this.optimalZoomLevel(
          Math.max(...allLat),
          Math.min(...allLat),
          Math.max(...allLng),
          Math.min(...allLng)
        )
      }else{
        this.map.zoom = this.defaultZoomLevel
      }

      this.map.mapCenter = {
        lat: latlngbounds.getCenter().lat(),
        lng: latlngbounds.getCenter().lng()
      }

    },

    adjustContentHeight(){
      var totalHeight = document.querySelector("html").offsetHeight
      var navHeight = document.querySelector("header > nav").offsetHeight
      var filterHeight = document.querySelector("#mapsNavi").offsetHeight

      var mapsHeight = (totalHeight - (navHeight + filterHeight))

      document.getElementById('productMap').style.height = mapsHeight;
      document.getElementById('productList').style.height = mapsHeight;
      document.querySelector("footer").style.display = "none"
      document.querySelector("body").style.overflow ="hidden"
    }
  }
}